<div class="modal-overlay">
  <div class="card modal-xl mx-auto border-0">
    <div
      class="card-header bergh-bg-primary documents-link-custom-css text-white"
    >
      Afdichtingen aan document koppelen
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-6 col-md-6 col-xl-6">
          <div class="row">
            <label class="col-12">
              <h6>Beschikbare afdichtingen</h6>
            </label>
            <div class="col-12">
              <div class="form-group">
                <label>Plattegrond</label>
                <select
                  class="form-control"
                  id="ddwn-floor"
                  [(ngModel)]="map"
                  (change)="getAvailableFpForDocument(true)"
                >
                  <option value="" id="optionDefault">
                    Alle plattegronden
                  </option>
                  @for (data of mapList; track data) {
                  <option [value]="data._id">{{ data.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label>Status</label>
                <select
                  class="form-control"
                  id="ddwn-status"
                  [(ngModel)]="status"
                  (change)="getAvailableFpForDocument(true)"
                >
                  <option value="" id="optionDefault">Kies status</option>
                  @for (data of fpStatus; track data; let i = $index) {
                  <option [value]="data._id" id="option-{{ i }}">
                    {{ data.nameDutch }}
                  </option>
                  }
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Soort</label>
                <select
                  class="form-control"
                  id="ddwn-kind"
                  [(ngModel)]="kind"
                  (change)="getAvailableFpForDocument(true)"
                >
                  <option value="" id="optionDefault">Kies soort</option>
                  @for (data of fpTypes; track data; let i = $index) {
                  <option [value]="data._id" id="option-{{ i }}">
                    {{ data.nameDutch }}
                  </option>
                  }
                </select>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Meerwerk</label>
                <select
                  class="form-control"
                  id="ddwn-extrawork"
                  [(ngModel)]="selectedExtraWork"
                  (change)="getAvailableFpForDocument(true)"
                >
                  <option value="null" id="optionDefault">Kies meerwerk</option>
                  @for (data of extraWork; track data; let i = $index) {
                  <option [value]="data.isextraWork" id="option-{{ i }}">
                    {{ data.name }}
                  </option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group header mb-2">
                @if (availableFP.length>0) {
                <button
                  class="btn btn-success float-right mb-2"
                  (click)="linkDelinkAllPopOver('Link')"
                >
                  Alle toevoegen
                </button>
                }
              </div>
            </div>
            <div class="col-12">
              <table class="table border bg-white">
                <thead>
                  <tr>
                    <th scope="col" class="text-small text-truncate">
                      Afdichting
                    </th>
                    <th scope="col" class="text-small text-truncate">Status</th>
                    <th scope="col" class="text-small text-truncate">Soort</th>
                    <th scope="col" class="text-small text-truncate">
                      Meerwerk
                    </th>
                    <th scope="col" class="actions">Acties</th>
                  </tr>
                </thead>
                <tbody>
                  @for (data of availableFP; track data; let i = $index) {
                  <tr>
                    <td class="text-small text-truncate">
                      <div class="d-flex">
                        {{ data.code }}
                      </div>
                    </td>
                    <td class="text-small text-truncate">
                      {{ $any(data.status).nameDutch }}
                    </td>
                    <td class="text-small text-truncate">
                      {{ $any(data.type).nameDutch }}
                    </td>
                    <td class="text-small text-truncate">
                      {{ data.isExtraWork ? "Ja" : "Nee" }}
                    </td>
                    <td class="text-small text-truncate">
                      <div class="d-flex">
                        <button
                          type="button"
                          class="btn btn-secondary p-0 mr-1"
                          (click)="openInfoModel(data._id)"
                        >
                          <i-feather
                            name="alert-circle"
                            class="small-icon"
                          ></i-feather>
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary p-0"
                          (click)="linkDelinkPopOver(data, i, 'Link')"
                        >
                          <i-feather
                            name="arrow-right"
                            class="small-icon"
                          ></i-feather>
                        </button>
                      </div>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              @if (selectedFP) {
              <bergh-fire-partition-info
                [firePartitionData]="selectedFP"
                (cancel)="this.selectedFP = null"
              ></bergh-fire-partition-info>
              } @if (!loading) {
              <bergh-paginator
                [total]="total"
                [itemPerPage]="itemPerPage"
                [currentPageNumber]="currentPageNumber"
                (currentPageChange)="
                  currentPageNumber = $event; getAvailableFpForDocument()
                "
              ></bergh-paginator>
              }
            </div>

            @if (availableFP.length < 1) {
            <div class="col-12">
              <div class="alert alert-primary bergh-text-primary text-center">
                Geen data gevonden
              </div>
            </div>
            }
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-xl-6">
          <div class="row">
            <label class="col-12">
              <h6 class="col-9">Gekoppelde afdichtingen</h6>
              @if (coupledList.length>0) {
              <button
                class="btn btn-danger float-right col-3 mr-3"
                (click)="linkDelinkAllPopOver('Delink')"
              >
                Alle ontkoppelen
              </button>
              }
            </label>
          </div>
          @if (coupledList.length < 1) {
          <div class="co-12">
            <div class="alert alert-primary bergh-text-primary text-center">
              Geen data gevonden
            </div>
          </div>
          }

          <div class="col-12">
            <table class="table border bg-white">
              <tbody>
                @for (data of coupledList; track data; let i = $index) {
                <tr>
                  <td class="text-small text-truncate">
                    <div class="d-flex">
                      {{ data.code }}
                    </div>
                  </td>
                  <td class="text-small text-truncate actions">
                    <button
                      type="button"
                      class="btn btn-danger p-0"
                      (click)="linkDelinkPopOver(data, i, 'Delink')"
                    >
                      <i-feather name="trash-2" class="small-icon"></i-feather>
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      <button
        class="btn btn-secondary mr-2"
        (click)="cancel.emit(false)"
        id="btn-cancel"
      >
        Sluiten
      </button>
    </div>
  </div>
</div>

@if (popUpData || popUpAllType) {
<bergh-alert-link-unlink
  [isLink]="popUpLink"
  [popUpAllType]="popUpAllType"
  (isConfirmLink)="
    linkFP(this.popUpData, this.popUpIndex);
    popUpData = null;
    popUpIndex = null;
    popUpLink = null
  "
  (isConfirmUnlink)="
    deLinkFP(this.popUpData, this.popUpIndex);
    popUpData = null;
    popUpIndex = null;
    popUpLink = null
  "
  (isConfirmAllLink)="linkDelinkAllFP('Link'); this.popUpAllType = null"
  (isConfirmAllUnlink)="linkDelinkAllFP('Delink'); this.popUpAllType = null"
  (cancel)="
    popUpData = null; popUpIndex = null; popUpLink = null; popUpAllType = null
  "
>
</bergh-alert-link-unlink>
}
